import { observer } from 'mobx-react';
import React from 'react';

export interface IUserInactiveProfileBannerProps {
  isProfileActive: boolean;
}

export const UserInactiveProfileBanner = observer(
  ({ isProfileActive }: IUserInactiveProfileBannerProps) => {
    return (
      <>
        {!isProfileActive && (
          <div className="bannerContainer-danger text-center">
            <b className="bannerText">INACTIVE PROFILE</b>
          </div>
        )}
      </>
    );
  }
);
